// extracted by mini-css-extract-plugin
export default {"container":"Form_container__K-uLg","form":"Form_form__psS5c","error":"Form_error__HaRg7"};